export const getFilters = (state) => state.framlLanding.filters;
export const getSort = (state) => state.framlLanding.sort;
export const getPagination = (state) => state.framlLanding.pagination;
export const getCustomers = (state) => state.framlLanding.customers;
export const getSummary = (state) => state.framlLanding.summary;
export const getCustomerAlerts = (state, key) =>
  state.framlLanding.customerAlerts[key];
